<script lang="ts" setup>
defineOptions({
    inheritAttrs: false,
});

const props = withDefaults(defineProps<{
    to?: string,
    href?: string,
    external?: boolean,
    target?: string,
    rel?: string,
    activeClass?: string,
    exactActiveClass?: string,
}>(), {
    activeClass: '',
    exactActiveClass: '',
});

const hydrationReady = useState<boolean>('hydration-ready', () => false);
const linkTarget = computed(() => props.to || props.href || '#');
const rel = computed(() => props.rel || (props.target === '_blank' ? 'noopener' : undefined));
</script>

<template>
  <NuxtLink
          v-if="hydrationReady"
          v-bind="$attrs"
          :active-class="activeClass"
          :exact-active-class="exactActiveClass"
          :external="external"
          :rel="rel"
          :target="target"
          :to="linkTarget"
  >
    <slot/>
  </NuxtLink>
  <a
          v-else
          v-bind="$attrs"
          :href="linkTarget"
          :rel="rel"
          :target="target"
  >
    <slot/>
  </a>
</template>
